import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-read-only-button',
    templateUrl: './read-only.component.html',
    styleUrls: ['./read-only.component.scss'],
    standalone: true
})
export class ReadOnlyComponent implements OnInit {
  @Input() idEntity: string;
  @Output() readOnlyEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  readOnlyRoute() {
    this.readOnlyEvent.emit(this.idEntity);
  }

}
